import { Dispatch } from 'redux';

import { Events } from '../constants/webSocketConsts/events';
import { PaymentLink, paymentLinksApi } from '../services/api/paymentLinksApi';

import { updateListCache } from './updateListCache';

export function handlePaymentLinkUpdate(
  event: Events,
  items: PaymentLink[],
  dispatch: Dispatch<any>,
) {
  const [item] = items;
  dispatch(
    paymentLinksApi.util.updateQueryData(
      'listPaymentLinks',
      undefined,
      (draft?: PaymentLink[]) => {
        updateListCache(event, items, draft);
      },
    ),
  );
  dispatch(
    paymentLinksApi.util.updateQueryData(
      'getPaymentLink',
      item.id,
      (draft: PaymentLink) => {
        Object.assign(draft, item);
      },
    ),
  );
}
